
    import Vue from "vue";
    import AllocationCheckInTimeModal from "@/views/Modals/BookingsModals/AllocationCheckInTimeModal.vue"
    import AllocationDateModal from "@/views/Modals/BookingsModals/AllocationDateModal.vue"
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import { ApiClient } from "@/utilities/ApiClient";
    import { BookingVM } from "@/model/Api/VM/BookingVM";
    import { BookingRoomTotalsVM, IBookingRoomTotalsVM } from "@/model/Api/VM/BookingRoomTotalsVM";
    import { IBookingAllocationDate } from "@/model/BookingAllocationDate";
    import { IBookingAllocationVM } from "@/model/Api/VM/BookingAllocationVM";
    import { IBookingProfile } from "@/model/BookingProfile";
    import { Prop } from "vue-property-decorator";
    import { IBookingAllocation } from "@/model/BookingAllocation";
    import vuescroll from "vuescroll";
    import { Utils } from "@/utilities/Utils";
    import Loader from "@/views/Loader.vue"

    @Component({
        components: {
            AllocationCheckInTimeModal,
            AllocationDateModal,
            ApiButton,
            Loader
        }
    })

    export default class AllocationTab extends Vue {


        ops = {
            // The following configurations correspond to different parts of Vuescroll.
            bar: {
                background: 'none',
                disable: true
            }
        }

        //
        // -- properties
        //

        @Prop({}) private booking !: BookingVM;
        @Prop({}) private bookingAllocations !: Array<IBookingAllocationVM>;
        @Prop({}) private bookingProfiles !: Array<IBookingProfile>;
        @Prop({}) private roomTotals !: Array<IBookingRoomTotalsVM>;
        selectedAllocationID: number = 0;
        selectedBookingID: number = -1; // unallocated uses 0 as an id so we need another number to respresent a 'blank' hotel ID
        private loaderActive: boolean = false;

        // computed

        private get roomTotalsColour(): string {
            let retVal = "red";
            if (this.totalRoomsAllocated == this.totalRoomsRequired) {
                retVal = "black";
            }
            return retVal;
        }

        private get totalRoomsAllocated(): number {
            let retVal = 0
            if (this.roomTotals.length > 0) {
                for (const total of this.roomTotals) {
                    retVal += total.roomsAssigned
                }
            }
            return retVal;
        }

        private get totalRoomsRequired(): number {
            let retVal = 0
            if (this.roomTotals.length > 0) {
                for (const total of this.roomTotals) {
                    retVal += total.roomsRequired
                }
            }
            return retVal;
        }

        private get isDisabled() {
            let retVal = 0

            if (this.booking.statusID === 3) { retVal = 1 }
            if (this.booking.statusID === 4) { retVal = 1 }
            if (this.booking.statusID === 5) { retVal = 1 }
            if (this.booking.statusID === 6) { retVal = 1 }
            if (this.booking.statusID === 8) { retVal = 1 }
            return retVal;
        }

        private isFullyAllocated(id: number) {

            let assigned = this.roomTotals.filter(r => r.profileID === id)[0];

            if (assigned == undefined) {
                return false;
            }

            if (assigned.roomsAssigned == assigned.roomsRequired) {
                return true;
            }
            else {
                return false;
            }
        }

        //
        // -- Methods
        //

        // async loadRoomTotals() {
        //     this.roomTotals = [];
        //     const response = await ApiClient.get(`/Api/Booking/BookingRoomTotals?id=${this.booking.id}`);
        //     this.roomTotals.push(...response.map((r: IBookingRoomTotalsVM) => new BookingRoomTotalsVM(r)));
        // }

        async assignDate(date: IBookingAllocationDate, event: Event) {
            this.loaderActive = Utils.showLoader();
            // https://vuescrolljs.yvescoding.org/guide/configuration.html
            const scrollLeft = this.$refs.vueScrollBar as vuescroll & { getPosition: () => 0 };
            const scroller = scrollLeft.getPosition().scrollLeft
            const scroll = this.$refs.vueScrollBar as vuescroll & { scrollTo: () => 0 };
            const roomTotal = this.roomTotals.find(r => r.profileID == date.profileID);
            if (roomTotal?.roomsRequired == roomTotal?.roomsAssigned) {
                this.loaderActive = Utils.hideLoader();
                toastr.warning("All rooms have been allocated for this date"); return;
            }
            const postData = { bookingID: this.booking.id, objectID: date.id }
            await ApiClient.post("/Api/Booking/DateAssign", postData, event);
            this.$emit("loadRoomTotals");
            this.$emit("loadAllocationsDetail");
            scroll.scrollTo({ x: scroller }, 500)
            this.loaderActive = Utils.hideLoader();
        }

        async removeDate(date: IBookingAllocationDate, event: Event) {
            this.loaderActive = Utils.showLoader();
            // https://vuescrolljs.yvescoding.org/guide/configuration.html
            const scrollLeft = this.$refs.vueScrollBar as vuescroll & { getPosition: () => 0 };
            const scroller = scrollLeft.getPosition().scrollLeft
            const scroll = this.$refs.vueScrollBar as vuescroll & { scrollTo: () => 0 };
            const postData = { bookingID: this.booking.id, objectID: date.id }
            await ApiClient.post("/Api/Booking/DateAssign", postData, event);
            this.$emit("loadRoomTotals");
            this.$emit("loadAllocationsDetail");
            scroll.scrollTo({ x: scroller }, 500)
            this.loaderActive = Utils.hideLoader();
        }

        async editAllocationDate(allocation: IBookingAllocationVM, allocationDate: IBookingAllocationDate) {
            const dialogue = this.$refs.allocationDateModal as AllocationDateModal & { show: () => void };
            dialogue.show(allocation.allocation.id, allocation.employee.forename + " " + allocation.employee.surname, allocationDate, this.booking.id);
        }

        async selectAllDates(allocation: IBookingAllocation, event: Event) {
            this.loaderActive = Utils.showLoader();
            const postData = { bookingID: this.booking.id, objectID: allocation.id }
            await ApiClient.post("/Api/Booking/AllocationSelectAllDates", postData, event);
            this.$emit("loadAllocationsDetail");
            this.$emit("loadRoomTotals");
            this.loaderActive = Utils.hideLoader();
        }

        async editCheckInTime(allocation: IBookingAllocationVM) {
            this.loaderActive = Utils.showLoader();
            const dialogue = this.$refs.allocationCheckInTimeModal as AllocationCheckInTimeModal & { show: () => void };
            dialogue.show(allocation.allocation.id, allocation.employee.forename + " " + allocation.employee.surname);
            this.loaderActive = Utils.hideLoader();

        }

        loadAllocationsDetail() {
            this.$emit("loadAllocationsDetail");
        }

        loadRoomTotals() {
            this.$emit("loadRoomTotals");
        }

        loadHotels() {
            this.$emit("loadHotels");
        }


    }
